import React, { DetailedHTMLProps, HTMLAttributes, MouseEventHandler } from 'react'

import classNames from 'classnames'

import style from './Budge.module.css'

import { ReactComponent as CrossIcon } from 'assets/icons/cross-icon.svg'
import { capitalize } from 'common/utils'

type DefaultDivPropsType = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>

type PropsType = {
  children: string
  variant?: 'basic' | 'clearable'
  className?: string
  onClear?: () => void
  onClick?: () => void
} & DefaultDivPropsType

export const Badge = ({
  variant = 'basic',
  children,
  onClear,
  onClick,
  className = '',
  ...props
}: PropsType) => {
  const badgeClickHandler: MouseEventHandler<HTMLButtonElement> = e => {
    e.stopPropagation()
    onClick && onClick()
  }

  return (
    <div className={classNames(style.badge, style[`badge--${variant}`], className)} {...props}>
      <button className={style.text} disabled={variant === 'clearable'} onClick={badgeClickHandler}>
        {capitalize(children)}
      </button>
      {onClear && (
        <button className={style['remover']} onClick={onClear}>
          <CrossIcon className={style['cross']} />
        </button>
      )}
    </div>
  )
}
